import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import CallCard from '../callCard'
import { DesktopCard } from './DesktopCards/DesktopCard'
import { FlexContainer } from '../Kit/Container'
import { selectAutoJoinChat, selectRedirectDialog } from '../../reducers/uiSlice'
import { CannotDeleteMessageDialog } from '../dialogs/CannotDeleteMessageDialog'
import { ChatErrorDialog } from '../dialogs/ChatErrorDialog'
import { useViews } from 'state'
import { TermsAndConditions } from '../dialogs/TermsAndConditions'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { PayPalCheckoutDialog } from '../dialogs/PayPalCheckoutDialog'
import { useDevices } from '@gojiraf/responsive'
import { RedirectDialog } from '../dialogs/RedirectDialog'
import { ChatDesktop } from '../Chat/ChatDesktop'
import CallService from '../../services/callService'
import { useEvent } from '../../hooks/useEvent'
import { useStore } from 'state'
import { useEventById } from '../../hooks/use-event-by-id'

const Container = styled(FlexContainer)`
  flex-direction: row;
  justify-content: center;
  align-items: ${({ isMobile }) => (isMobile ? 'start' : 'center')};
  width: 100%;
  height: 100vh;
  height: 100dvh;
  gap: 1em;
`

const Call = () => {
  const { close } = useEvent()
  const { data: event } = useEventById()
  const { store, event: eventData } = useStore()
  const {
    storeConfigurations: {
      features: { termsAndConditions, chat },
    },
  } = store
  const { isDesktop } = useDevices()
  const autoJoinChat = useSelector(selectAutoJoinChat)
  const {
    showDialog: showRedirectDialog,
    paymentGateway,
    orderData,
    externalUrl,
    title,
  } = useSelector(selectRedirectDialog)
  const { send: sendViews } = useViews()
  const { postHogTrackEvent } = usePostHogAnalytics()

  const { REACT_APP_DEFAULT_VIEW_MOBILE = 'SHOW_CHAT' } = process.env

  useEffect(() => {
    if (!store || !eventData || event === undefined) return

    postHogTrackEvent('event-entered-live', {
      status: event.status,
    })

    const timeoutId = setTimeout(() => {
      postHogTrackEvent('event-user-active')
    }, 15000)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [store, eventData, event])

  useEffect(() => {
    const view = autoJoinChat ? REACT_APP_DEFAULT_VIEW_MOBILE : 'SHOW_CHAT'
    sendViews({ type: view })
  }, [])

  // Esto deberia manejarse en un hook de subscripcion al servicio de Notificaciones.
  useEffect(() => {
    CallService.joinNotificationsChannel(event.eventId)

    return () => {
      CallService.unsubscribeNotifications()
    }
  }, [event.eventId])

  return (
    <Container isMobile={!isDesktop}>
      {isDesktop && chat.enabled ? <ChatDesktop /> : null}
      <CallCard close={close} />
      <TermsAndConditions customTermsAndConditions={termsAndConditions} />
      <PayPalCheckoutDialog />
      <CannotDeleteMessageDialog />
      {showRedirectDialog && (
        <RedirectDialog
          paymentGateway={paymentGateway}
          externalUrl={externalUrl}
          orderData={orderData}
          title={title}
        />
      )}
      <ChatErrorDialog />
      {isDesktop && <DesktopCard />}
    </Container>
  )
}

export { Call }
